var _polygon, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHoldPrevious = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "6.50293 4.5 6.48999 4.49915 5.75293 3.42615 5.01398 4.49915 5.00293 4.5 5.00201 4.51617 1.96002 8.94312 3.19604 9.79291 5.00201 7.16412 5.00293 14 6.50293 14 6.50201 7.16412 8.30981 9.79291 9.54584 8.94312 6.50201 4.51617 6.50293 4.5",
  fillRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 1.5,
  r: 1.5
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 5.75,
  cy: 1.5,
  r: 1.5
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 1.5,
  cy: 1.5,
  r: 1.5
})));
export default SvgHoldPrevious;